module.exports = __webpack_public_path__ + "img/avatar_default.08803b0d.png";